<form [formGroup]="attributeValueForm" (ngSubmit)="submitAttributeValueForm()">
  <div class="row">
    <div class="col-md-6 mb-3">
      <!-- <label for="" class="form-label">Attribute Value <span class="text-danger">*</span></label>
    <ng-select class="ng-select-md" placeholder="Select" [appendTo]="'body'">
      <ng-option selected>THD</ng-option>
    </ng-select> -->
      <input-field
        [label]="'Attribute Value'"
        [placeholder]="'Enter Attribute Value'"
        [requiredLabel]="true"
        [errormessage]="'Attribute Value is required'"
        [required]="true"
        formControlName="value"
      />
    </div>
    <!-- <div class="col-auto mt-4 pt-2">
      <div class="d-flex mt-1">
        <p class="me-2 mb-0">Validate</p>
        <p-toggleswitch formControlName="enabled" />
      </div>
    </div> -->
  </div>
</form>
